import React, { isValidElement } from "react";
import { ElementOrElementRenderer, ElementRenderer, IconProps } from "../types";
import { InputOwnProps } from "./input.types";

export interface InputEnhancerRendererProps {
  disabled: boolean;
  focused: boolean;
  success: boolean;
  error: boolean;
  color?: InputOwnProps["color"];
}

export interface InputEnhancerProps extends InputEnhancerRendererProps {
  elementOrRenderer: ElementOrElementRenderer<InputEnhancerRendererProps>;
}

export const InputEnhancer = React.memo(function InputEnhancer({
  elementOrRenderer,
  disabled,
  focused,
  success,
  error,
  color = "interactive",
}: InputEnhancerProps) {
  if (isValidElement<IconProps>(elementOrRenderer)) {
    const displayName = (elementOrRenderer.type as any)?.displayName as string;
    if (displayName && displayName.indexOf("Icon") === 0 && displayName !== "IconButton") {
      return React.cloneElement(elementOrRenderer, {
        color: disabled ? "gray" : error ? "error" : focused ? color : (elementOrRenderer.props as any).color ?? "gray",
      });
    } else {
      return elementOrRenderer;
    }
  } else {
    return (elementOrRenderer as ElementRenderer<InputEnhancerRendererProps>)({
      disabled,
      focused,
      success,
      error,
      color,
    });
  }
});
